"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationForm = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const formik_1 = require("formik");
const Input_1 = require("../components/form/Input/Input");
const Button_1 = require("../components/Button/Button");
exports.InvitationForm = ({ context, message }) => {
    const { t } = react_i18next_1.useTranslation('AcceptInvitationScene');
    return (react_1.default.createElement(formik_1.Form, null,
        react_1.default.createElement(Input_1.Input, { name: "password", type: "password", label: t('password'), id: `${context}-password-input` }),
        react_1.default.createElement("div", { className: "text-center" }, message),
        react_1.default.createElement(Button_1.Button, { className: "float-right", type: "submit", id: `${context}-button` }, t('button'))));
};
//# sourceMappingURL=InvitationForm.js.map